import { t } from 'i18next';
// styles
import styles from './AgreementHeaderList.module.css';

const AgreementHeaderList = () => {
    return (
        <div className={styles['wrapper']}>
            <div className={styles['name']}>
                <p>{t('settings.commercialAgreements.sett_placeholderTitleCommercialAgreements')}</p>
            </div>
            <div className={styles['quantity']}>
                <p>{t('settings.commercialAgreements.sett_Agreements')}</p>
            </div>
            <div className={styles['updated_at']}>
                <p>{t('settings.commercialAgreements.sett_Update')}</p>
            </div>
            <div className={styles['next_to_expire']}>
                <p>{t('settings.commercialAgreements.sett_nextDeadline').split(" ")[1]}</p>
            </div>
            <div className={styles['pdv']}>
                <p>{t('settings.commercialAgreements.sett_tabPointsOfSale')}</p>
            </div>
            <div className={styles['delete']}></div>
        </div>
    );
};

export default AgreementHeaderList;
